import { gql } from '@apollo/client';

export const READ_NEXT_QUERY = gql`
  query ReadNext($offset: Int, $perPage: Int, $id: Int) {
    posts: readNextPosts(
      request: { exclude: [$id], offset: $offset, perPage: $perPage }
    ) {
      totalCount
      totalPage
      items {
        id
        title
        propertyType
        author {
          id
          name
          nickname
          description
          link
          total_post
        }
        tags {
          id
          name
          link
        }
        project {
          id
          name
          propertyType
          developer
          roomTypes {
            name
          }
          location {
            zone {
              label
              value
              link
              parent {
                value
                label
                link
              }
            }
            district {
              label
              value
              link
              parent {
                value
                label
                link
              }
            }
            road {
              label
              value
              link
              parent {
                value
                label
                link
              }
            }
          }
          transportations {
            value
            label
            link
          }
          priceTypes {
            starting_price
            level {
              value
              label
            }
          }
        }
        postCategory
        link
        videoType
        featuredImage {
          url
          title
          width
          height
        }
        totalComments
        embedVideo
      }
    }
  }
`;
